
export default class ReadmoreComponent {
  constructor(element) {
    this.el = element;

    this.readMoreLink = this.el.querySelector("[data-readmore]");
    this.content = this.el.querySelector("[data-content]");
    this.contentWrapper = this.el.querySelector(".content-wrapper");

    this.toggleHeight = this.toggleHeight.bind(this);
    this.init()
  }

  init() {

    this.readMoreLink && this.readMoreLink.addEventListener("click", () => {
      this.toggleHeight();
    })
  }

  toggleHeight()
  {
    var height = this.content.clientHeight;


    if(this.el.classList.contains("open"))
    {
      this.contentWrapper.style.height = `${height}px`;
      this.el.classList.remove("open");

      

      setTimeout(() => {
        this.contentWrapper.style.height = `0px`;
        this.el.setAttribute("aria-expanded", "false");
      }, 50);  
    }
    else{
      this.el.classList.add("open");
      this.contentWrapper.style.height = `${height}px`;

      // Allows the height to be fully flexible if height is changed on device while in an open state
      setTimeout(() => {
        this.contentWrapper.style.height = `auto`;
        this.el.setAttribute("aria-expanded", "true");
      }, 1000) 
      
    }
  }


}
